/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit StartsAt/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function StartsAt({
  children,
  viewPath = "/App/Account/WaitingRoom/Content/Content/Waiting/Appointments/Content/Appointment/StartsAt"
  
}) {
let appointmentBookingLocalStartTimeValueData = fromData.useDataValue({ viewPath,
context: 'appointment_booking',
path: 'local_start_time',
})
let aggregateData = fromAggregate.localStartTimeWithFormat(appointmentBookingLocalStartTimeValueData)
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={2}
 cursor="pointer"
 size="small"
 weight="semibold"
 color={dtColorsNeutral700}
 data="appointment_booking.local_start_time"
 aggregate="/Data/aggregate.js localStartTimeWithFormat"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}